export default __webpack_public_path__ + "static/media/Banner-Deimare.63395a22.png";